export class ReviewGroupPage
{
	constructor()
	{
	}
}